import clsx from 'clsx'
import {useEffect} from 'react'
import {Button} from 'swayok-react-mdb-ui-kit/components/Button/Button'
import {NavigationService} from 'swayok-react-mdb-ui-kit/services/NavigationService'
import {appUrl} from '../../../AppUrl'
import {trans} from '../../../helpers'
import {useAuthStore} from '../../../stores'

interface TopNavigationCreateAdButtonProps {
    forDropdownMenu?: boolean
}

// Кнопка "Разместить объявление" в верхнем меню навигации.
export function TopNavigationCreateAdButton(props: TopNavigationCreateAdButtonProps) {
    const {
        forDropdownMenu = false,
    } = props

    const setOnRegistrationSuccess = useAuthStore(
        state => state.setOnRegistrationSuccess
    )
    const setOnLoginSuccess = useAuthStore(
        state => state.setOnLoginSuccess
    )

    const url = appUrl().cabinet.ads.create
    const label = trans().common.top_navigation.add_advertisement

    // Настраиваем поведение после логина и регистрации.
    useEffect(() => {
        setOnRegistrationSuccess(() => {
            NavigationService.navigate(appUrl().cabinet.ads.create)
            return 'stop'
        })
        setOnLoginSuccess(() => {
            NavigationService.navigate(appUrl().cabinet.ads.create)
        })
    }, [])

    if (forDropdownMenu) {
        return (
            <Button
                color="blue"
                className={clsx(
                    'text-nowrap full-width'
                )}
                href={url}
            >
                {label}
            </Button>
        )
    } else {
        return (
            <Button
                color="blue"
                className={clsx(
                    'top-nav-add-listing-btn lh-1 flex-shrink-0 fw-700'
                )}
                href={url}
            >
                {/* Так нужно для правильной анимации внутри <HorizontalCollapse> */}
                <span className="d-block full-height flex-center">
                    {label}
                </span>
            </Button>
        )
    }
}
